import { Search } from "lucide-react";
import { type FC, useEffect, useState } from "react";

import { CustomInput } from "@/components/atoms";
import {
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

interface SearchInputSubMenuProps {
  category: string;
  initialValue?: string;
  onApply: (category: string, value: string) => void;
  placeholder?: string;
}

const SearchInputSubMenu: FC<SearchInputSubMenuProps> = ({
  category,
  initialValue = "",
  onApply,
  placeholder = "Search...",
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key !== "Escape") {
      e.stopPropagation();
    }
    if (e.key === "Enter") {
      onApply(category, value);
    }
  };

  return (
    <>
      <DropdownMenuLabel
        className="flex items-center gap-2 relative p-0"
        data-testid="search-input-label"
      >
        <Search
          size={16}
          className="absolute top-2.5 left-3 z-20"
          color="#6B7280"
        />
        <CustomInput
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={() => onApply(category, value)}
          className="placeholder:text-xs text-gray-950 font-normal border-none h-10 pl-9 pr-3 focus-visible:outline-none focus-visible:ring-0 w-[200px]"
          data-testid="search-input-field"
          autoFocus
        />
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <div className="p-2 text-[10px] text-gray-400">
        Press Enter or click outside to apply
      </div>
    </>
  );
};

export default SearchInputSubMenu;
